import get from 'lodash/get';

const getSort = (entity) => (state) => get(state, `sort.${entity}`, {});
export default getSort;
